<template>
  <div class="d-flex flex-column" style="height: 100%;">
    <SearchBar v-model="search_filter">
      <template #extra_buttons>
        <FilterDialog />
        <CreateDialog v-if="userIsAdmin" />
      </template>

      <template #results>
        <div class="text-center grey--text text--darken-3" style="font-size: 12px;">
          {{ allPros.length }} Pros
        </div>
      </template>
    </SearchBar>
    
    <template v-if="!error">
      <v-list two-line v-if="filtered.length > 0" class="rounded-lg" style="overflow-y: scroll">
        <template v-for="(pro, index) in filtered">
          <v-divider :key="`divider-${index}`" v-if="index > 0"/>
          <v-list-item 
            :key="pro.pro_id" 
            @click="$emit('drill-down', pro)"
            :ripple="false"
            class="pr-3"
          >
            <v-list-item-content>
              <v-list-item-title class="d-flex pr-1" :class="{ 'grey--text': isPaused(pro) }">
                <div class="d-flex align-center font-weight-bold">
                  <div class="truncate" style="max-width: 250px">
                    {{ pro.business_name }}
                  </div>
                  <v-icon v-if="pro.account_claimed" small color="orange darken-2" class="ml-1">
                    mdi-alpha-c-circle-outline
                  </v-icon>
                </div>
                <div class="ml-auto text-body-2 grey--text">{{ pro.address ? pro.address.city : '' }}</div>
              </v-list-item-title>
              <v-list-item-subtitle class="d-flex pr-1" :class="{ 'grey--text': isPaused(pro) }">
                <div class="mr-auto">{{ pro.contact_name }}</div>
                <div v-if="pro.new" class="red--text pr-1">
                  <strong>NEW</strong>
                </div>
                <div v-if="isPaused(pro)">
                  <em>Paused</em>
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        </template>
      </v-list>
      <div v-else class="d-flex flex-column align-center mt-4">
        <div>No Pros were found matching that criteria.</div>
        <v-icon size="100px" color="yellow darken-2" class="mt-4">
          mdi-emoticon-sad-outline
        </v-icon>
      </div> 
    </template>
    <div v-else class="d-flex flex-column align-center mt-4">
      <div class="px-4 text-center">
        Out-of-Network Pros requires that you have a validated business address.
        Please go your <router-link :to="{ name: 'account' }">Account Profile</router-link> to update it.
      </div>
      <v-icon size="100px" color="red" class="mt-4">
        mdi-emoticon-sad-outline
      </v-icon>
    </div> 
  </div>
</template>

<script>
import CreateDialog from './dialogs/CreateDialog'
import FilterDialog from './dialogs/FilterDialog'
import SearchBar from '@/components/SearchBar'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProsList',

  components: {
    CreateDialog,
    FilterDialog,
    SearchBar,
  },

  data() {
    return {
      search_filter: '',

      error: false,
    }
  },
  
  computed: {
    ...mapGetters('auth', ['userIsAdmin']),
    ...mapGetters('filters', ['partnerFilters']),
    ...mapGetters('pros', { allPros: 'all' }),

    queryFilters() {
      let newFilters = { ...this.partnerFilters }
      if (!this.userIsAdmin)
        newFilters.in_network = 1
      
      return newFilters
    },

    filtered() {
      let qualified = this.allPros
      if (!this.search_filter) {
        return qualified
      } else {
        const filt = this.search_filter.toLowerCase()
        return qualified.filter(
            pro => pro.business_name.toLowerCase().includes(filt) ||
            pro.contact_name.toLowerCase().includes(filt) ||
            pro.address.city.toLowerCase().includes(filt)
        )
      }
    }
  },
  
  methods: {
    ...mapActions('filters', ['loadPartnerFilters']),
    ...mapActions('pros', ['loadAll']),

    isPaused: pro => pro.partnership_status == 'paused',
  },
 
  watch: {
    async queryFilters(newVal) {
      const result = await this.loadAll(newVal)

      this.error = !result.ok
    }
  },

  async created() {
    const changed = await this.loadPartnerFilters()
    if(!changed) {
      const result = await this.loadAll(this.queryFilters)

      this.error = !result.ok
    }
  }
}
</script>

<style scoped>

.truncate {  
  white-space: nowrap;  
  overflow: hidden;  
  text-overflow: ellipsis;  
}
</style>